import React, { useEffect, useState } from 'react';
import { Alert as MuiAlert, Snackbar } from 'components/ui/MaterialAdapter';

const Alert = (props) => (
  <MuiAlert elevation={6} variant="filled" {...props} />
);

const BanInspecting = () => {
  const [openWarning, setOpenWarning] = useState(false);

  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault(); // Disable right-click context menu
      setOpenWarning(true);
    };

    const handleKeyDown = (e) => {
      // Detecting F12, Ctrl+Shift+I, or Ctrl+U for opening dev tools
      if (e.key === 'F12' || (e.ctrlKey && e.shiftKey && e.key === 'I') || (e.ctrlKey && e.key === 'U')) {
        e.preventDefault();
        setOpenWarning(true);
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenWarning(false);
  };

  return (
    <div id="inspect-warning-container">
      {/* Snackbar Warning */}
      <Snackbar
        id="snackbar-inspect-warning"
        open={openWarning}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          id="alert-inspect-warning"
          onClose={handleClose}
          severity="warning"
          sx={{ width: '100%' }}
        >
          <strong>Warning:</strong> Inspecting is not allowed!
        </Alert>
      </Snackbar>
    </div>
  );

};

export default BanInspecting;
